module.exports = __webpack_public_path__ + "img/destination_europe.a2145577.webp";